import { Input } from '@nike/frame-component-library';
import { isNone } from '@nike/rcf-fp';
import PropTypes from 'prop-types';
import React, { useState } from 'react';

import { provisionRegister } from '../../../../utils/service-calls/fiskaly';
import { REQUIRED_FIELD } from '../../../../utils/validation/input-validation';
import { ButtonBlack, ButtonSubmit } from '../../../reusable';

const isBlank = (value) => isNone(value) || value === '';

const RegisterForm = ({
  userToken, storeId, onProvisioned, onCancel,
}) => {
  const [registerId, setRegisterId] = useState('');
  const [saving, setSaving] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const validateRegisterId = () => (isBlank(registerId) ? REQUIRED_FIELD : '');

  const submit = () => {
    setSaving(true);
    setErrorMessage('');
    const payload = { registerId, storeId };
    console.log('Provisioning register with payload:', payload);
    return provisionRegister(userToken, payload)
      .then(({ body }) => {
        onProvisioned(body);
        return body;
      })
      .catch((err) => {
        setErrorMessage(`Failed to provision register: ${err.message}`);
        setSaving(false);
      });
  };

  return (
    <main className="ncss-row ta-sm-c">
      <section className="ta-sm-l bg-primary-grey pt2-sm pb2-sm prl2-sm border">
        <header className="u-rounded bg-black va-sm-m pt2-sm pb2-sm mb2-sm">
          <span className="headline-3 pl3-sm text-color-primary-light">
            General
          </span>
        </header>
        <article className="ncss-col-sm-6 va-sm-t">
          <Input
            isDisabled
            label="Store ID"
            value={storeId}
            onChange={() => null}
          />
        </article>
        <article className="ncss-col-sm-6 va-sm-t">
          <Input
            errorMessage={validateRegisterId()}
            label="Register ID"
            value={registerId}
            onChange={(e) => setRegisterId(e.target.value)}
          />
        </article>
      </section>
      <footer className="ncss-row">
        <ButtonSubmit
          isDisabled={validateRegisterId() !== ''}
          isLoading={saving}
          label="Provision Register"
          onClick={submit}
        />
        {onCancel && (
          <ButtonBlack
            label="Cancel"
            onClick={onCancel}
          />
        )}
      </footer>
      {errorMessage && (
        <p className="text-color-error ta-sm-c body-2 mt2-sm">
          {errorMessage}
        </p>
      )}
    </main>
  );
};

RegisterForm.defaultProps = {
  onCancel: null,
  onProvisioned: () => null,
};

RegisterForm.propTypes = {
  onCancel: PropTypes.func,
  onProvisioned: PropTypes.func,
  storeId: PropTypes.string.isRequired,
  userToken: PropTypes.string.isRequired,
};

export default RegisterForm;
